import React from "react";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { IoChevronDownOutline, IoChevronUpOutline } from "react-icons/io5";
import "../../styles/ExerciseItemDedicated.css"; // Use dedicated CSS file

const ExerciseItem = ({ exercise, expanded, toggleExpand, onEditClick, onDeleteClick }) => {

    const difficultyMapping = {
        BASIC: "Podstawowy",
        INTERMEDIATE: "Średniozaawansowany",
        ADVANCED: "Zaawansowany"
    };

    const getDifficultyClass = (difficultyLevel) => {
        // Debug: log the difficulty level
        console.log('Difficulty level received:', difficultyLevel);

        // Ensure we have a valid difficulty level and convert to lowercase
        const normalizedLevel = difficultyLevel ? difficultyLevel.toString().toLowerCase() : 'basic';
        console.log('Normalized level:', normalizedLevel);

        // Return completely unique class names
        return `ex-diff-badge ex-diff-${normalizedLevel}`;
    };

    const getDifficultyStyle = (difficultyLevel) => {
        // Debug: log the difficulty level to see what we're receiving
        console.log('getDifficultyStyle - difficulty level received:', difficultyLevel, typeof difficultyLevel);

        // Inline styles as backup to guarantee colors work
        const styles = {
            BASIC: { backgroundColor: '#CCE745', color: '#17803D' },
            INTERMEDIATE: { backgroundColor: '#F2A516', color: 'white' },
            ADVANCED: { backgroundColor: '#E77845', color: 'white' },
            // Also handle lowercase versions
            basic: { backgroundColor: '#CCE745', color: '#17803D' },
            intermediate: { backgroundColor: '#F2A516', color: 'white' },
            advanced: { backgroundColor: '#E77845', color: 'white' },
            // Handle Polish translations just in case
            'Podstawowy': { backgroundColor: '#CCE745', color: '#17803D' },
            'Średniozaawansowany': { backgroundColor: '#F2A516', color: 'white' },
            'Zaawansowany': { backgroundColor: '#E77845', color: 'white' }
        };

        const result = styles[difficultyLevel] || styles.BASIC;
        console.log('getDifficultyStyle - returning style:', result);
        return result;
    };

    return (
        <div
            className={`exercise-item ${expanded ? 'expanded' : ''}`}
            onClick={toggleExpand}
        >
            <div className="exercise-header">
                <div className="exercise-info">
                    <h3 className="exercise-name">{exercise.name}</h3>
                    <div className="exercise-meta">
                        <span
                            className={getDifficultyClass(exercise.difficultyLevel)}
                            style={getDifficultyStyle(exercise.difficultyLevel)}
                        >
                            {difficultyMapping[exercise.difficultyLevel] || exercise.difficultyLevel}
                        </span>
                    </div>
                </div>
                <div className="exercise-actions">
                    <AiOutlineEdit
                        size={20}
                        className="exercise-edit-icon"
                        onClick={(e) => {
                            e.stopPropagation();
                            onEditClick(exercise);
                        }}
                        title="Edytuj ćwiczenie"
                    />
                    <AiOutlineDelete
                        size={20}
                        className="exercise-delete-icon"
                        onClick={(e) => {
                            e.stopPropagation();
                            onDeleteClick(exercise);
                        }}
                        title="Usuń ćwiczenie"
                    />
                    {expanded ? (
                        <IoChevronUpOutline
                            size={20}
                            className="exercise-expand-icon expanded"
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleExpand();
                            }}
                            title="Ukryj szczegóły"
                        />
                    ) : (
                        <IoChevronDownOutline
                            size={20}
                            className="exercise-expand-icon"
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleExpand();
                            }}
                            title="Pokaż szczegóły"
                        />
                    )}
                </div>
            </div>

            {expanded && (
                <div className="exercise-details">
                    <div className="exercise-details-content">
                        <div className="exercise-detail-section">
                            <p className="exercise-detail-title">Opis</p>
                            <p className="exercise-detail-text">{exercise.description || 'Brak opisu'}</p>
                        </div>
                        {exercise.requiredEquipment && (
                            <div className="exercise-detail-section">
                                <p className="exercise-detail-title">Wymagany sprzęt</p>
                                <p className="exercise-detail-text">{exercise.requiredEquipment}</p>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ExerciseItem;